import { useNavigation } from '@/app/hooks'
import { UtilityPlanSelection } from '@/app/features/utility-plan-selection'

export type SelectUtilityFlowStepProps = {
  /** Optional override for the continue action (defaults to the account-number step). */
  onNext?: () => void
}

/**
 * Profile "utility information" wrapper around the shared utility/plan selection
 * page. There is no program here, so eligibility gating is off; "+ Add my plan"
 * opens the existing manual-plan flow and Continue advances to the account-number
 * step.
 */
export default function SelectUtilityFlowStep({
  onNext,
}: SelectUtilityFlowStepProps) {
  const navigation = useNavigation()
  return (
    <UtilityPlanSelection
      onContinue={
        onNext ?? (() => navigation.push('/connect-utility/account-number'))
      }
      onAddPlan={() => navigation.push('/connect-utility/plan/manual-select')}
    />
  )
}
